/**
 * Created by smart on 2018/10/31.
 * Email:chengshuai.tj@gmail.com
 * Author:Smart
 * Description: 报名结果页面数据，title content step均为必备key，content为空时候不显示，step如不用，赋值[]即可
 *  1：自营 2：个人无车优驾 3：个人有车优驾 4：企业无车优驾 5：企业有车优驾
 * 目前只区分三个类型 自营（1） 优驾（2、3） 企业（4、5）
 */
export const EnrollStatusUPlus = {
  '待审核': {
    title: '报名信息已提交，待审核',
    content: '我们会以短信形式通知您审核结果',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '待审核'
      }
    ]
  },
  '退回待修改': {
    title: '审核未通过，待修改',
    content: '请重新上传不合格的照片',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核未通过，待修改'
      }
    ]
  },
  /**
   * TODO 审核未通过
   */
  '审核未通过': {
    title: '审核未通过',
    content: '非常抱歉，您的报名信息审核未通过',
    step: []
  },
  '待通知面试': {
    title: '审核通过，等待面试通知',
    content: '我们会以短信形式通知您面试信息',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '报名信息审核通过'
      },
      {
        num: 3,
        text: '待通知面试'
      }
    ]
  },
  '待预约面试': {
    title: '待预约面试',
    content: '请尽快预约面试时间',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '报名信息审核通过'
      },
      {
        num: 3,
        text: '待预约面试'
      }
    ]
  },
  '待面试': {
    title: '待面试',
    content: '',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '报名信息审核通过'
      },
      {
        num: 3,
        text: '待面试'
      }
    ]
  },
  '待背景调查': {
    title: '面试通过，待身份安全验证',
    content: '我们会以短信形式通知您身份安全验证结果',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '报名信息审核通过'
      },
      {
        num: 3,
        text: '面试通过'
      },
      {
        num: 4,
        text: '待身份安全验证'
      }
    ]
  },
  '待通知签约': {
    title: '身份安全验证通过，等待签约通知',
    content: '我们会以短信形式通知您签约信息',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '报名信息审核通过'
      },
      {
        num: 3,
        text: '面试通过'
      },
      {
        num: 4,
        text: '身份安全验证通过'
      },
      {
        num: 5,
        text: '等待签约通知'
      }
    ]
  },
  '待签约': {
    title: '待签约',
    content: '',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '报名信息审核通过'
      },
      {
        num: 3,
        text: '面试通过'
      },
      {
        num: 4,
        text: '身份安全验证通过'
      },
      {
        num: 5,
        text: '待签约'
      }
    ]
  },
  '已签约': {
    title: '成功加入神州专车',
    content: '恭喜您，您已成功加入神州专车\n更多信息详见短信通知',
    step: []
  },
  '报名失败': {
    title: '报名失败',
    content: '',
    step: []
  }
}
export const EnrollStatusCompany = {
  '首次待审核': {
    title: '企业初审通过，待平台审核',
    content: '我们会以短信形式通知您审核结果',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '企业初审通过'
      },
      {
        num: 3,
        text: '待平台审核'
      }
    ]
  },
  '待企业初审': {
    title: '报名信息已提交，待企业初审',
    content: '我们会以短信形式通知您审核结果',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '待企业初审'
      }
    ]
  },
  '初审不通过': {
    title: '报名信息已提交，待企业初审',
    content: '我们会以短信形式通知您审核结果',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '待企业初审'
      }
    ]
  },
  '复核不通过': {
    title: '企业初审未通过',
    content: '非常抱歉，您的报名信息企业初审未通过',
    step: []
  },
  '复核通过': {
    title: '企业初审未通过',
    content: '非常抱歉，您的报名信息企业初审未通过',
    step: []
  },
  '复核退回修改': {
    title: '企业初审未通过',
    content: '非常抱歉，您的报名信息企业初审未通过',
    step: []
  },
  '待平台审核': {
    title: '企业初审通过，待平台审核',
    content: '我们会以短信形式通知您审核结果',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '企业初审通过'
      },
      {
        num: 3,
        text: '待平台审核'
      }
    ]
  },
  '退回待修改': {
    title: '审核未通过，待修改',
    content: '请重新上传不合格的照片',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '企业初审通过'
      },
      {
        num: 3,
        text: '平台审核不通过（待修改信息）'
      }
    ]
  },
  /**
   * TODO 审核未通过
   */
  '审核未通过': {
    title: '审核未通过',
    content: '非常抱歉，您的报名信息审核未通过',
    step: []
  },
  '待通知面试': {
    title: '审核通过，等待面试通知',
    content: '我们会以短信形式通知您面试信息',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '企业初审通过'
      },
      {
        num: 3,
        text: '报名信息审核通过'
      },
      {
        num: 4,
        text: '待通知面试'
      }
    ]
  },
  '待预约面试': {
    title: '待预约面试',
    content: '请尽快预约面试时间',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '企业初审通过'
      },
      {
        num: 3,
        text: '报名信息审核通过'
      },
      {
        num: 4,
        text: '待预约面试'
      }
    ]
  },
  '待面试': {
    title: '待面试',
    content: '',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '企业初审通过'
      },
      {
        num: 3,
        text: '报名信息审核通过'
      },
      {
        num: 4,
        text: '待面试'
      }
    ]
  },
  '待背景调查': {
    title: '面试通过，待身份安全验证',
    content: '我们会以短信形式通知您身份安全验证结果',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '企业初审通过'
      },
      {
        num: 3,
        text: '报名信息审核通过'
      },
      {
        num: 4,
        text: '面试通过'
      },
      {
        num: 5,
        text: '待身份安全验证'
      }
    ]
  },
  '待通知签约': {
    title: '身份安全验证通过，等待签约通知',
    content: '我们会以短信形式通知您签约信息',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '企业初审通过'
      },
      {
        num: 3,
        text: '报名信息审核通过'
      },
      {
        num: 4,
        text: '面试通过'
      },
      {
        num: 5,
        text: '身份安全验证通过'
      },
      {
        num: 6,
        text: '等待签约通知'
      }
    ]
  },
  '待签约': {
    title: '待签约',
    content: '',
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '企业初审通过'
      },
      {
        num: 3,
        text: '报名信息审核通过'
      },
      {
        num: 4,
        text: '面试通过'
      },
      {
        num: 5,
        text: '身份安全验证通过'
      },
      {
        num: 6,
        text: '待签约'
      }
    ]
  },
  '已签约': {
    title: '成功加入神州专车',
    content: '恭喜您，您已成功加入神州专车\n更多信息详见短信通知',
    step: []
  },
  '报名失败': {
    title: '报名失败',
    content: '',
    step: []
  }
}
export const failReason = {
  13: '未通过面试',
  22: '未及时参加面试',
  21: '未及时预约面试',
  15: '未通过身份安全验证',
  18: '未成功签约',
  23: '未及时签约'
}
export const failReasonForCompany = {
  913: '未通过面试',
  922: '未及时参加面试',
  921: '未及时预约面试',
  915: '未通过身份安全验证',
  918: '未成功签约',
  923: '未及时签约'
}
/**
 * 用于对应接口的状态和前端页面的状态，多个接口状态对应一个页面状态
 * map格式解释: { 接口返回服务器的招募状态码: 前端状态 // 接口状态码解释 }
 */
export const ServerTypeConverter = {
  uPlus: {
    2: '待审核',
    4: '退回待修改',
    5: '待审核',
    6: '审核未通过',
    9: '待通知面试',
    10: '待预约面试',
    11: '待通知面试',
    12: '待面试',
    14: '待背景调查',
    16: '待通知签约',
    17: '待签约',
    19: '已签约',
    20: '审核未通过'
  },
  company: {
    902: '首次待审核',
    200: '待企业初审',
    202: '初审不通过',
    212: '复核不通过',
    211: '复核通过',
    214: '复核退回修改',
    903: '审核未通过',
    904: '退回待修改',
    905: '待平台审核',
    906: '审核未通过',
    909: '待通知面试',
    910: '待预约面试',
    911: '待通知面试',
    912: '待面试',
    914: '待背景调查',
    916: '待通知签约',
    917: '待签约',
    919: '已签约',
    920: '审核未通过'
  },
  team: {
    1: '待初审',
    11: '初审不通过',
    2: '待洽谈',
    12: '洽谈不合作',
    3: '待复审',
    14: '复审退回',
    13: '复审不通过',
    4: '待签约',
    15: '签约失败',
    5: '待合同审核',
    16: '合同退回',
    6: '待开通',
    7: '已开通',
    17: '已过期'
  }
}

export const teamStatus = {
  '待初审': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '待审核'
      }
    ],
    current: 2
  },
  '初审不通过': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核未通过'
      }
    ],
    current: 2
  },
  '待洽谈': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核通过'
      },
      {
        num: 3,
        text: '待业务洽谈'
      }
    ],
    current: 3
  },
  '洽谈不合作': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核通过'
      },
      {
        num: 3,
        text: '洽谈不合作'
      }
    ],
    current: 3
  },
  '待复审': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核通过'
      },
      {
        num: 3,
        text: '确认合作'
      },
      {
        num: 4,
        text: '资质审核中'
      }
    ],
    current: 4
  },
  '复审退回': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核通过'
      },
      {
        num: 3,
        text: '确认合作'
      },
      {
        num: 4,
        text: '资质审核中'
      }
    ],
    current: 4
  },
  '复审不通过': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核通过'
      },
      {
        num: 3,
        text: '确认合作'
      },
      {
        num: 4,
        text: '资质审核未通过'
      }
    ],
    current: 4
  },
  '待签约': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核通过'
      },
      {
        num: 3,
        text: '确认合作'
      },
      {
        num: 4,
        text: '资质审核通过'
      },
      {
        num: 5,
        text: '待签约'
      }
    ],
    current: 5
  },
  '签约失败': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核通过'
      },
      {
        num: 3,
        text: '确认合作'
      },
      {
        num: 4,
        text: '资质审核通过'
      },
      {
        num: 5,
        text: '签约失败'
      }
    ],
    current: 5
  },
  '待合同审核': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核通过'
      },
      {
        num: 3,
        text: '确认合作'
      },
      {
        num: 4,
        text: '资质审核通过'
      },
      {
        num: 5,
        text: '签约完成'
      },
      {
        num: 6,
        text: '合同备案中'
      }
    ],
    current: 6
  },
  '合同退回': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核通过'
      },
      {
        num: 3,
        text: '确认合作'
      },
      {
        num: 4,
        text: '资质审核通过'
      },
      {
        num: 5,
        text: '签约完成'
      },
      {
        num: 6,
        text: '合同备案中'
      }
    ],
    current: 6
  },
  '待开通': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核通过'
      },
      {
        num: 3,
        text: '确认合作'
      },
      {
        num: 4,
        text: '资质审核通过'
      },
      {
        num: 5,
        text: '签约完成'
      },
      {
        num: 6,
        text: '合同备案完成'
      },
      {
        num: 7,
        text: '待激活账号'
      }
    ],
    current: 7
  },
  '已开通': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核通过'
      },
      {
        num: 3,
        text: '确认合作'
      },
      {
        num: 4,
        text: '资质审核通过'
      },
      {
        num: 5,
        text: '签约完成'
      },
      {
        num: 6,
        text: '合同备案完成'
      },
      {
        num: 7,
        text: '账号已开通'
      }
    ],
    current: 7
  },
  '已过期': {
    step: [
      {
        num: 1,
        text: '报名成功'
      },
      {
        num: 2,
        text: '审核通过'
      },
      {
        num: 3,
        text: '确认合作'
      },
      {
        num: 4,
        text: '资质审核通过'
      },
      {
        num: 5,
        text: '签约完成'
      },
      {
        num: 6,
        text: '合同备案完成'
      },
      {
        num: 7,
        text: '申请过期'
      }
    ],
    current: 7
  }
}
